<template>
  <div class="churn-survey">
    <survey-page v-if="!surveyCompleted"
                 :question-types="questionTypes"
                 :questions="[question]"
                 :page-title="'שאלה אחת וסיימנו!'"
                 :set-answer="setAnswer"
                 :buttonTitle="'סיימתי'"
                 :buttonAction="saveAnswers"/>
    <alert-page v-else :emoji="'🙏'"
                :title="'תודה!'"
                :showButton="false">
      <template v-slot:content>התשובה שלך תעזור לנו להמשיך ולשפר את השירות.</template>
    </alert-page>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Segment from '../../../../Segment';
import SurveyPage from '../../../../base-components/survey/SurveyPage.vue';
import AlertPage from '../../../../base-components/AlertPage.vue';

export default {
  name: 'ChurnSurvey',
  components: {
    SurveyPage,
    AlertPage,
  },
  created() {
    Segment.trackUserGot('ChurnSurveyEntered');
  },
  computed: {
    ...mapState('churnSurvey', ['question', 'surveyCompleted', 'questionTypes']),
    ...mapGetters('churnSurvey', ['isEmptyAnswer']),
  },
  methods: {
    ...mapActions('churnSurvey', ['setAnswer', 'saveAnswers']),
    async saveSurveyAnswers() {
      Segment.trackUserInteraction('ChurnSurveyAnsweredClicked', {});
      await this.saveAnswers();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .churn-survey {
    padding: 2px 20px 23px 23px;
  }
</style>
